import { resolveEnvironment } from './environment';

export const environment = resolveEnvironment({
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_APP_ENV: process.env.REACT_APP_APP_ENV,
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
});
